const scrollUpBtn = document.querySelector('#scroll-up-btn');

/**
 * Debounce function
 *
 * @param {Function} func function to invoke
 * @param {number} wait miliseconds
 * @returns {Function} callback function
 */
function throttle(func, wait) {
  let waiting = false;

  return function (...args) {
    if (!waiting) {
      func.apply(this, args);
      waiting = true;
      setTimeout(() => {
        waiting = false;
      }, wait);
    }
  };
}

/**
 * Calculate current page scroll and apply logic
 */
function handleScroll() {
  const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
  const scrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
  const scrolledRatio = scrollTop / scrollHeight;

  if (scrolledRatio > 0.3) {
    scrollUpBtn.classList.add('show');
  } else {
    scrollUpBtn.classList.remove('show');
  }
}

/**
 * Init
 */
function init() {
  if (document.documentElement.scrollHeight < 3000) return;
  scrollUpBtn.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  window.addEventListener('scroll', throttle(handleScroll, 250));
}

init();
